import { FORBIDDEN } from 'http-status-codes';

import fetchRecommendations from 'src/api/fetch-recommendations';
import fetchFavouriteStatus from 'src/api/fetch-favourite-status';
import combineOffersWithFavourites from 'src/api/combine-offers-with-favourites';


const SET_OFFERS = 'SET_OFFERS';
const REMOVE_OFFER = 'REMOVE_OFFER';
const TOGGLE_OFFER_FAVOURITE_STATUS = 'TOGGLE_OFFER_FAVOURITE_STATUS';
const SET_AGREEMENT = 'SET_AGREEMENT';


const setOffers = offers => ({
  type: SET_OFFERS,
  payload: {
    offers
  }
});

const toggleOfferFavouriteStatus = ({ offerId, isFavourite }) => ({
  type: TOGGLE_OFFER_FAVOURITE_STATUS,
  payload: {
    offerId,
    isFavourite
  }
});

const removeOffer = offerId => ({
  type: REMOVE_OFFER,
  payload: {
    offerId
  }
});


const setProfilingAgreement = hasProfilingAgreement => ({
  type: SET_AGREEMENT,
  payload: {
    hasProfilingAgreement
  }
});

const getRecommendations = () => async (dispatch, getState, { http }) => {
  const {
    contextReducer: { context },
    credentialsReducer: { mpUserId, identityId }
  } = getState();

  const [offers, fetchError] = await fetchRecommendations({
    http,
    params: {
      context,
      mpUserId: mpUserId || null,
      identityId: identityId || null
    }
  })
    .then(data => [data, null])
    .catch(error => [[], error]);

  if (fetchError && fetchError.response && fetchError.response.status === FORBIDDEN) {
    dispatch(setProfilingAgreement(false));
  } else {
    dispatch(setProfilingAgreement(true));
  }

  return offers;
};

const getFavouritesStatus = offers => async (dispatch, getState, { http }) => {
  const offerIds = offers
    .reduce((params, { offerId }) => !params.append('offerIds', offerId) && params, new URLSearchParams());

  const [statuses] = await fetchFavouriteStatus({
    http,
    params: offerIds
  })
    .then(data => [data, null])
    .catch(error => [[], error]);

  return statuses;
};


const getOffers = () => async (dispatch, getState) => {
  const {
    credentialsReducer: { mpUserId }
  } = getState();

  const offers = await dispatch(getRecommendations());

  if (!mpUserId || offers.length === 0) {
    dispatch(setOffers(offers));
    return;
  }

  const favourites = await dispatch(getFavouritesStatus(offers));
  dispatch(setOffers(combineOffersWithFavourites({ offers, favourites })));
};

export {
  SET_OFFERS,
  REMOVE_OFFER,
  TOGGLE_OFFER_FAVOURITE_STATUS,
  SET_AGREEMENT,
  setOffers,
  toggleOfferFavouriteStatus,
  removeOffer,
  setProfilingAgreement,
  getOffers
};
